<!-- Data Extraction Page Container -->
<div class="data-extraction-container">
  <!-- Header Navigation - Same as loan-validation -->
  <app-page-header></app-page-header>

  <!-- Main Content -->
  <div class="page-content">
    <div class="content-section">
      <div class="evaluation-section-header">
        <div class="evaluation-section-title-wrap">
          <button
            class="section-back-btn"
            (click)="router.navigate(['/home'])"
            title="Back to Dashboard"
            aria-label="Back to Dashboard">
            <svg
              class="back-arrow-icon"
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.7"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true">
              <path d="M19 12H5"></path>
              <path d="M12 19l-7-7 7-7"></path>
            </svg>
          </button>
          <h2 class="evaluation-section-title">Data Extraction Sandbox</h2>
        </div>
      </div>
      <!-- Extraction Form Section -->
      <div class="extraction-controls-wrapper">
        <div class="extraction-controls-grid">
            <!-- PDF File Input -->
            <div class="form-group pdf-input-group">
              <label class="form-label">PDF File</label>
              <div class="pdf-file-input-wrapper">
                <button class="pdf-file-input-btn" [class.file-uploaded]="getSelectedFileName() !== pdfPlaceholder" (click)="triggerFileInput()" [title]="getSelectedFileName() !== pdfPlaceholder ? 'PDF file: ' + getSelectedFileName() : ''">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="upload-icon">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                    <polyline points="17 8 12 3 7 8"></polyline>
                    <line x1="12" y1="3" x2="12" y2="15"></line>
                  </svg>
                  <span class="file-name-text" [title]="getSelectedFileName() !== pdfPlaceholder ? getSelectedFileName() : ''">{{ getSelectedFileName() }}</span>
                  @if (getSelectedFileName() !== pdfPlaceholder) {
                    <span class="file-uploaded-icon" aria-label="File uploaded" title="PDF file uploaded">
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="20 6 9 17 4 12"></polyline>
                      </svg>
                    </span>
                  }
                </button>
                <input
                  id="pdf-file-input"
                  type="file"
                  accept=".pdf"
                  (change)="onFileSelected($event)"
                  style="display: none;"
                  aria-label="Select PDF file">
              </div>
              @if (fileInputError) {
                <div class="form-error">{{ fileInputError }}</div>
              }
            </div>

            <!-- Document Model Selector -->
            <div class="form-group">
              <label class="form-label">Document Model</label>
              <div class="searchable-select-container">
                <input
                  type="text"
                  class="form-select searchable-select-input-trigger"
                  [class.dropdown-open]="openDropdown === 'documentModel'"
                  [placeholder]="getDropdownPlaceholder('documentModel')"
                  [value]="selectedDocumentModel"
                  readonly
                  (focus)="onDropdownFocus('documentModel')"
                  (blur)="onDropdownBlur()"
                  >
                @if (openDropdown === 'documentModel') {
                  <div class="searchable-select-dropdown">
                    <!-- Search Input Inside Dropdown -->
                    <div class="dropdown-search-container">
                      <input
                        type="text"
                        class="dropdown-search-input"
                        [(ngModel)]="documentModelSearch"
                        (input)="onSearchChange('documentModel')"
                        (mousedown)="$event.stopPropagation()"
                        placeholder="Search document models"
                        autofocus
                        >
                      @if (documentModelSearch) {
                        <button class="clear-search-btn" (click)="documentModelSearch = ''; onSearchChange('documentModel')" (mousedown)="$event.stopPropagation()" type="button" title="Clear search">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <line x1="18" y1="6" x2="6" y2="18"></line>
                            <line x1="6" y1="6" x2="18" y2="18"></line>
                          </svg>
                        </button>
                      }
                    </div>
                    <div class="searchable-select-options">
                      @if (filteredDocumentModels.length === 0) {
                        <div class="no-options">No models found</div>
                      } @else {
                        @for (model of filteredDocumentModels; track model.code) {
                          <button class="option-item" (click)="selectOption('documentModel', model.code)" type="button">
                            {{ model.name }}
                          </button>
                        }
                      }
                    </div>
                  </div>
                }
              </div>
              @if (modelsLoadError) {
                <div class="form-error">{{ modelsLoadError }}</div>
              }
            </div>

            <!-- OCR Mode Selector -->
            <div class="form-group">
              <label class="form-label">OCR Mode</label>
              <div class="searchable-select-container">
                <input
                  type="text"
                  class="form-select searchable-select-input-trigger"
                  [class.dropdown-open]="openDropdown === 'ocrMode'"
                  [class.read-only-field]="!canEditOcrLlmOptions"
                  [disabled]="!selectedDocumentModel && canEditOcrLlmOptions"
                  [attr.aria-disabled]="!canEditOcrLlmOptions"
                  [title]="!canEditOcrLlmOptions ? 'OCR Mode cannot be changed for your role' : ''"
                  [placeholder]="getOcrModePlaceholder()"
                  [value]="selectedOcrMode"
                  [readonly]="true"
                  (focus)="onDropdownFocus('ocrMode')"
                  (blur)="onDropdownBlur()">
                @if (openDropdown === 'ocrMode' && canEditOcrLlmOptions) {
                  <div class="searchable-select-dropdown">
                    <!-- Search Input Inside Dropdown -->
                    <div class="dropdown-search-container">
                      <input
                        type="text"
                        class="dropdown-search-input"
                        [(ngModel)]="ocrModeSearch"
                        (input)="onSearchChange('ocrMode')"
                        (mousedown)="$event.stopPropagation()"
                        placeholder="Search OCR modes"
                        autofocus
                        title="Search OCR modes">
                      @if (ocrModeSearch) {
                        <button class="clear-search-btn" (click)="ocrModeSearch = ''; onSearchChange('ocrMode')" (mousedown)="$event.stopPropagation()" type="button" title="Clear search">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <line x1="18" y1="6" x2="6" y2="18"></line>
                            <line x1="6" y1="6" x2="18" y2="18"></line>
                          </svg>
                        </button>
                      }
                    </div>
                    <div class="searchable-select-options">
                      @if (filteredOcrModes.length === 0) {
                        <div class="no-options">No modes found</div>
                      } @else {
                        @for (mode of filteredOcrModes; track mode) {
                          <button class="option-item" (click)="selectOption('ocrMode', mode)" type="button">
                            {{ mode }}
                          </button>
                        }
                      }
                    </div>
                  </div>
                }
              </div>
            </div>

            <!-- LLM Model Selector -->
            <div class="form-group">
              <label class="form-label">LLM Model</label>
              <div class="searchable-select-container">
                <input
                  type="text"
                  class="form-select searchable-select-input-trigger"
                  [class.dropdown-open]="openDropdown === 'llmModel'"
                  [class.read-only-field]="!canEditOcrLlmOptions"
                  [disabled]="!selectedDocumentModel && canEditOcrLlmOptions"
                  [attr.aria-disabled]="!canEditOcrLlmOptions"
                  [title]="!canEditOcrLlmOptions ? 'LLM Model cannot be changed for your role' : ''"
                  [placeholder]="getLlmModelPlaceholder()"
                  [value]="selectedLlmModel"
                  [readonly]="true"
                  (focus)="onDropdownFocus('llmModel')"
                  (blur)="onDropdownBlur()">
                @if (openDropdown === 'llmModel' && canEditOcrLlmOptions) {
                  <div class="searchable-select-dropdown">
                    <!-- Search Input Inside Dropdown -->
                    <div class="dropdown-search-container">
                      <input
                        type="text"
                        class="dropdown-search-input"
                        [(ngModel)]="llmModelSearch"
                        (input)="onSearchChange('llmModel')"
                        (mousedown)="$event.stopPropagation()"
                        placeholder="Search LLM models"
                        autofocus
                        title="Search LLM models">
                      @if (llmModelSearch) {
                        <button class="clear-search-btn" (click)="llmModelSearch = ''; onSearchChange('llmModel')" (mousedown)="$event.stopPropagation()" type="button" title="Clear search">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <line x1="18" y1="6" x2="6" y2="18"></line>
                            <line x1="6" y1="6" x2="18" y2="18"></line>
                          </svg>
                        </button>
                      }
                    </div>
                    <div class="searchable-select-options">
                      @if (filteredLlmModels.length === 0) {
                        <div class="no-options">No models found</div>
                      } @else {
                        @for (model of filteredLlmModels; track model) {
                          <button class="option-item" (click)="selectOption('llmModel', model)" type="button">
                            {{ model }}
                          </button>
                        }
                      }
                    </div>
                  </div>
                }
              </div>
            </div>

            <!-- Extract Button -->
            <div class="form-group extract-btn-group">
              <label class="form-label" style="visibility: hidden;">Action</label>
              <button
                class="btn-extract"
                (click)="extractData()"
                [disabled]="!canExtract()"
                [class.btn-loading]="isExtracting"
                [title]="!canExtract() ? (getSelectedFileName() === pdfPlaceholder && !selectedDocumentModel ? 'Please upload a PDF file and select a document model before running extraction' : getSelectedFileName() === pdfPlaceholder ? 'Please upload a PDF file before running extraction' : 'Please select a document model before running extraction') : ''">
                @if (isExtracting) {
                  <div class="btn-spinner"></div>
                  <span>Extracting...</span>
                } @else {
                  <span>Go</span>
                }
              </button>
            </div>
          </div>

        <!-- Recent Extraction Runs Section -->
        <div class="recent-runs-wrapper">
          <div class="recent-runs-header">
            <h3 class="recent-runs-title">Recent Extraction Runs</h3>
          </div>

          <!-- Extraction Runs Table -->
          <div class="runs-table-wrapper">
            <!-- Loading State -->
            @if (loadingFromAPI) {
              <div class="loading-state">
                <div class="loading-spinner"></div>
                <p class="loading-text">Loading extraction history...</p>
              </div>
            }

            <!-- Data Display (Hidden during loading) -->
            @if (!loadingFromAPI) {
              <table class="extraction-runs-table">
                <thead>
                  <tr>
                    <th class="col-file-name sortable" (click)="sortBy('fileName')">File Name <span class="sort-icon" [innerHTML]="getSortIcon('fileName')"></span></th>
                    <th class="col-pages sortable" (click)="sortBy('pages')">Pages <span class="sort-icon" [innerHTML]="getSortIcon('pages')"></span></th>
                    <th class="col-document-model sortable" (click)="sortBy('documentModel')">Document Model <span class="sort-icon" [innerHTML]="getSortIcon('documentModel')"></span></th>
                    <th class="col-ocr-mode sortable" (click)="sortBy('ocrMode')">OCR Mode <span class="sort-icon" [innerHTML]="getSortIcon('ocrMode')"></span></th>
                    <th class="col-llm-model sortable" (click)="sortBy('llmModel')">LLM Model <span class="sort-icon" [innerHTML]="getSortIcon('llmModel')"></span></th>
                    <th class="col-status sortable" (click)="sortBy('status')">Status <span class="sort-icon" [innerHTML]="getSortIcon('status')"></span></th>
                    <th class="col-started sortable" (click)="sortBy('startedDate')">Started At <span class="sort-icon" [innerHTML]="getSortIcon('startedDate')"></span></th>
                    <th class="col-duration sortable" (click)="sortBy('duration')">Duration <span class="sort-icon" [innerHTML]="getSortIcon('duration')"></span></th>
                    <th class="col-actions">Actions</th>
                  </tr>
                </thead>
                <tbody>
                @if (recentRuns.length === 0) {
                  <tr>
                    <td colspan="9" class="no-data-row">
                      <div class="no-data-message">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                          <circle cx="11" cy="11" r="8"></circle>
                          <path d="m21 21-4.35-4.35"></path>
                        </svg>
                        <p>No extraction runs found</p>
                      </div>
                    </td>
                  </tr>
                } @else {
                  @for (run of recentRuns; track run.id) {
                    <tr>
                      <td class="col-file-name">
                        <span class="file-name-text" [title]="run.fileName">{{ truncateFileNameDisplay(run.fileName) }}</span>
                        <div class="file-id" [title]="run.id">{{ run.id }}</div>
                      </td>
                      <td class="col-pages">
                        <span class="pages-badge">{{ (run.pages !== undefined && run.pages !== null) ? run.pages : '-' }}</span>
                      </td>
                      <td class="col-document-model">
                        <span class="document-model-text">{{ run.documentModel !== '-' ? run.documentModel : '-' }}</span>
                      </td>
                      <td class="col-ocr-mode">
                        <span class="ocr-mode-text">{{ run.ocrMode }}</span>
                      </td>
                      <td class="col-llm-model">
                        <span class="llm-model-text">{{ run.llmModel }}</span>
                      </td>
                      <td class="col-status">
                        <span class="status-badge" [class]="'status-' + getStatusClass(run.status)">
                          {{ run.status }}
                        </span>
                      </td>
                      <td class="col-started">
                        <div class="run-date">{{ run.startedDate | date:'mediumDate' }}</div>
                        <div class="run-time">{{ run.startedDate | date:'shortTime' }}</div>
                      </td>
                      <td class="col-duration">
                        <div class="duration-badge">
                          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <circle cx="12" cy="12" r="10"></circle>
                            <polyline points="12 6 12 12 16 14"></polyline>
                          </svg>
                          {{ getRunDuration(run) }}
                        </div>
                      </td>
                      <td class="col-actions">
                        <button class="btn-action btn-view btn-icon-only" (click)="viewRunDetails(run)" [disabled]="run.status !== 'Completed'" [title]="run.status === 'Running' ? 'Extraction in progress' : run.status === 'Failed' ? 'Failed run - cannot view results' : 'View Results'" [attr.aria-label]="run.status === 'Running' ? 'Extraction in progress for ' + run.fileName : run.status === 'Failed' ? 'Failed run for ' + run.fileName : 'View results for ' + run.fileName">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                            <circle cx="12" cy="12" r="3"></circle>
                          </svg>
                        </button>
                      </td>
                    </tr>
                  }
                }
              </tbody>
            </table>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
